import React, { useState, useEffect, useRef } from "react";
import autoplay from '../Assets/icon-auto-play.svg'
import play from '../Assets/icon-play.svg'
import icondd from '../Assets/icon-dd-arrow.svg'
import burger from '../Assets/icon-burger-menu.svg'
import coin from '../Assets/icon-coin.svg'
import plus from  '../Assets/icon-plus.svg'
import minus from  '../Assets/icon-minus.svg'
import star from '../Assets/whitestar.png'
import restar from '../Assets/restar.png'
import bomb from '../Assets/bomb.png'
import MinesDropdown from './MinesDropdown'
import { Switch } from '@mui/material'
import MinesPopUp from './MinesPopUp'
import start from '../Assets/sounds/mines/start.mp3'
import boom from '../Assets/sounds/mines/bomb.mp3'
import stars from '../Assets/sounds/mines/star.mp3'
import cashout from '../Assets/sounds/mines/cashout.mp3'
import emptymine from '../Assets/emptymine.png'
import initial from '../Assets/initializedspot.png'
import unselected from '../Assets/unselectedStar.png'
import explode from '../Assets/explode.png'

const MinesGame = ({ balance, setBalance }) => {
  const [isBetting, setIsBetting] = useState(false)
  const [grid, setGrid] = useState([]);
  const [revealed, setRevealed] = useState([]);
  const [gameOver, setGameOver] = useState(false);
  const [mines, setMines] = useState(3); // Default number of mines
  const [tilesRevealed, setTilesRevealed] = useState(0); // Tracks revealed tiles
  const [payoutMultiplier, setPayoutMultiplier] = useState(1); // Initial multiplier
  const [cashedOut, setCashedOut] = useState(false)
  const [betAmount, setBetAmount] = useState('50')

  // Base multiplier
  const baseMultiplier = 1.00;

 
  const totalTiles = 25; // 5x5 grid
  const totalMines = mines;  // 5 mines
  const safePicks = revealed.filter(Boolean).length;   // 3 safe picks made
  let previousMultiplier = 1

  const bombAudio = new Audio(boom);
  const starAudio = new Audio(stars);
  const cashoutAudio = new Audio(cashout);
  const startAudio = new Audio(start);
  const playStartSound = () => {
    startAudio.play();
  };
  const playStarSound = () => {
    starAudio.play();
  };
  const playBombSound = () => {
    bombAudio.play();
  };
  const playCashoutSound = () => {
    cashoutAudio.play();
  };

  // Update payout multiplier
  function calculateMultiplier() {
    // Validate inputs
    if (safePicks < 0 ) {
        throw new Error("Invalid number of safe picks.");
    }
    const tiles = totalTiles - mines
    const payout = totalTiles/(tiles - safePicks)
    const payoutMultiplier= previousMultiplier * payout  

    return payoutMultiplier.toFixed(2)
}

  const initializeGrid = () => {
    if(gameInitialized) return ;
    if(betAmount <= balance){
    playStartSound()
    setBalance(prev => prev - betAmount)
    setCashedOut(false)
    setCashOutAmount(0)
    setCashOutMultiplier(0)
    setIsBetting(true)
    const size = 5; // 5x5 grid
    const totalTiles = size * size;

    // Initialize grid with diamonds
    const newGrid = Array(totalTiles).fill("diamond");
    setNums(Array.from({ length: 25 }, (_,i) => (i)))

    // Place mines randomly
    for (let i = 0; i < mines; i++) {
      let index;
      do {
        index = Math.floor(Math.random() * newGrid.length);
      } while (newGrid[index] === "bomb");
      newGrid[index] = "bomb";}
      setGrid(newGrid);
      setRevealed(Array(totalTiles).fill(false));
      setGameOver(false);
      setTilesRevealed(0);
      setPayoutMultiplier(baseMultiplier); // Reset multiplier

      setGameInitialized(true)
    }

  };
  const [history, setHistory] = useState([]);
  const [cashOutAmount, setCashOutAmount] = useState(0)
  const [cashOutMultiplier, setCashOutMultiplier] = useState(1)
  const cashOut =()=>{
    if(safePicks > 0 ){
      playCashoutSound()
      setCashOutAmount(betAmount * payoutMultiplier)
      setCashOutMultiplier(payoutMultiplier)
      setCashedOut(true)
      updateHistory(payoutMultiplier)
      setPayoutMultiplier(1.00)
      setIsBetting(false)
      setGameOver(true);
      setBalance(prev => prev + betAmount * payoutMultiplier)
      setTimeout(() => {
        setGameInitialized(false)
      }, 5000);
    }
  }
  const [nums,setNums] = useState(Array.from({ length: 25 }, (_,i) => (i)))

  const handleClick = (index, payout=payoutMultiplier) => {
    setNums(nums.filter(num => num !== index))
    if (gameOver || revealed[index]) return;
    if (cashedOut) return;
    const updatedRevealed = [...revealed];
    updatedRevealed[index] = true;
    
    if (grid[index] === "bomb") {
      playBombSound()
      setGameOver(true);
      updateHistory('0.00')
      const updatedRevealed = [...revealed].map(()=> true)
      // updatedRevealed[index] = true;
      setRevealed(updatedRevealed);
      setNums(Array.from({ length: 25 }, (_,i) => (i)))
      setIsBetting(false)
      //   const updatedHistory = [...history];
      // updatedHistory[payout] = true;
      // setHistory(updatedHistory)
      setTimeout(() => {
        setGameInitialized(false)
      }, 5000);
    } else {
      const updatedRevealed = [...revealed];
      updatedRevealed[index] = true;
      playStarSound()
      setRevealed(updatedRevealed);
      previousMultiplier = calculateMultiplier()
      setPayoutMultiplier(calculateMultiplier()); // Update multiplier
    }

    setRevealed(updatedRevealed);
  };
  
  function pickRandomTile (){
  if(nums.length === 0) return ;
  const randomIndex = Math.floor(Math.random() * nums.length);
  const randomNumber = nums[randomIndex];
  handleClick(randomNumber)
  }


  const cashDisplay = payoutMultiplier * betAmount
  const scrollContainerRef = useRef(null);
  useEffect(()=>{
    if(scrollContainerRef.current){
      const scrollWidth = scrollContainerRef.current.scrollwidth
      const clientWidth = scrollContainerRef.current.clientWidth;
      scrollContainerRef.current.scrollTo({
        left:scrollWidth - clientWidth,
        scrollBehavior:'smooth'
      })
    }
  }, [])
  useEffect(() => {
    // if(betAmount < 1 && balance < 1) setBetAmount('1')

    if(betAmount > balance) setBetAmount(balance.toString())
  }, [betAmount])
  const updateHistory=(value)=>{
    setHistory([...history, value])
  }
 const [gameInitialized, setGameInitialized] = useState(false)
  const [showMines, setShowMines] = useState(false)
  function setMinesValue(value){
    setMines(value)
    setShowMines(false)
  }

  const [showBetAmt, setShowBetAmt] = useState(false)
  function setBetValue(value){
    setBetAmount(value.toString())
    setShowBetAmt(false)
  }

  const [keyPad, setKeyPad] = useState(false)
  function setKeyPadValue(value){
    if(value === '⌫'){
      setBetAmount(value.slice(0, -1))
    }else{
      setBetAmount(value.toString())
      setKeyPad(false)
    }
  }

  const [dropDown, setDropDown] = useState(false)
  const [popUp, setPopUp] = useState(false)


  const [autoPlay, setAutoPlay] = useState(false)
  const [autoPlayOptions, setAutoPlayOptions] = useState(false)
  function startAutoPlay(){
    setAutoPlayOptions(true)
  }
  const keys = [...Array.from({ length: 9 }, (_, i) => (i + 1).toString()), ".", '0', "⌫"];
  return (
    <div className="flex flex-col justify-between w-[100vw] h-full select-none sm:w-[500px] min-h-[100vh] p-[5px] bg-[#131419] items-center">
      <div className="bg-[#046cd2] flex flex-col justify-between items-center rounded-lg h-[98vh] w-full p-[2px]">
        <div className="flex flex-col w-full">

        <div className='flex justify-between bg-[#0d4f84] rounded-full w-full'>
          
          <button disabled={isBetting} onClick={() => setShowMines(!showMines)} className="flex justify-center items-center cursor-pointer space-x-4 rounded-full bg-[#0267a5] border border-[#043b5e] px-7">
            <p className="text-sm font-semibold text-white">Mines: {mines}</p>
            <img className="w-[8px]" src={icondd} alt=''/>
          </button>

          

          <div className="rounded-full bg-[#ffc107] px-4">
            <p className="text-sm text-[#434636] font-semibold">Next: {payoutMultiplier}x</p>
          </div>

        </div>
          <div className="h-[4px] mt-2 w-full bg-[#0d4f84]"/>

          { showMines && 
            <div className="absolute rounded-lg bg-[#021538] space-y-2 overflow-y-auto top-9 h-[180px] px-4 py-2">
          {Array.from({ length: 20 }).map((_, i) => (

          <div onClick={() => setMinesValue(i + 1)} key={i} className={`cursor-pointer ${i + 1 === mines ? 'bg-[#0d4f84]' : ''} hover:bg-[#0d4f84] flex space-x-4 rounded-full bg-[#043b5e]  px-10`}>
            <p className="text-sm text-center text-white">{i + 1}</p>
          </div>
             ))}
          </div>
          }
        </div>
          {
            dropDown &&
            <MinesDropdown/>
          }

{
            popUp &&
            <MinesPopUp/>
          }
        <div className="grid grid-cols-5 gap-2 p-4 w-[350px] ">
        {gameInitialized ? grid.map((item, index) => (
          <button

            key={index}
            disabled={gameOver || cashedOut}
            onClick={() => handleClick(index, payoutMultiplier)}
          >
            {revealed[index] && item === 'bomb' ? <img className="w-[60px] h-[45px]" src={explode} alt='star'/> : ''}
            {isBetting && revealed[index] && item === "diamond" ?
             <img className="w-[60px] h-[45px]" src={restar} alt='star'/>
             : 
             !gameOver && <img className="w-[60px] h-[45px]" src={initial} alt='star'/>}
            {/* {item === "bomb" ? "🎇" : ""}  */}
            {!isBetting && !revealed[index] &&  item === "bomb" ? <img className="w-[60px] h-[45px]" src={bomb} alt='bomb'/> : ""}
            {!isBetting &&  item === "diamond" ? <img className="w-[60px] h-[45px]" src={unselected} alt='star'/> : ""}

            
          </button>
        ))
          :
          Array.from({ length: 25 }).map((_, i) => (
            <img className="w-[60px] h-[45px]" src={emptymine} alt='emptymine'/>
          ))
      }
      </div>

        <div className="flex flex-col">
          <div className="flex justify-between items-center space-x-1">
            <p onClick={pickRandomTile} className={`w-[170px] text-center rounded-full px-4 font-semibold border border-[#02559c] ${isBetting ? 'text-white cursor-pointer' :'text-[#a4c9cf]'} bg-[#0366b5]`}>RANDOM</p>
            <div className="w-[170px] h-[27px] flex justify-center items-center rounded-full px-4 font-semibold border border-[#02559c] text-white bg-[#013b97]">
            <Switch
            value={'on'}
            disabled={isBetting}
              onChange={()=> setAutoPlay(!autoPlay)}
              sx={{
                  '& .MuiSwitch-switchBase.Mui-checked': {
                  color: '#efefef', // Thumb color when checked
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: '#2fff00', // Track color when checked
                  },
                  '& .MuiSwitch-track': {
                  backgroundColor: 'gray', // Default track color
                  },"& .MuiSwitch-track": {
                      border: "1px solid #8d8e8e", // Border for track
                    },
              }}
              />
              <p className="text-sm">Auto Game</p>
            </div>
          </div>
          
          <div className="relative rounded-lg my-2 flex flex-col justify-center items-center w-full bg-[#013798]">
            <div className="rounded-lg flex justify-center items-center w-full space-x-2 py-2">
            <button disabled={autoplay} onClick={() => setPopUp(!popUp)} className="rounded-full w-auto p-[0.6rem] bg-[#0258bf] shadow-lg border-2 border-[#012044]">
              <img src={autoplay} alt='autoplay'/>
            </button>
            {isBetting ? <button onClick={isBetting && cashOut } className={`cursor-pointer flex  flex-col justify-center items-center  ${safePicks > 0 ? 'bg-[#dda707]': 'bg-[#807151]'} rounded-2xl w-[230px] pb-1 shadow-black shadow-md border-2 border-[#000]`}>
              <p className="text-white">CASH OUT</p>
              {isBetting && <div className="flex space-x-2 rounded-[3px] bg-[#614a06] border-2 border-[#4b4c01] justify-center items-center text-[0.7rem]">
                  <p className="font-semibold text-white">{(betAmount * payoutMultiplier).toFixed(2)} USD</p>
              </div>}
            </button>
            :
            <button disabled={ autoPlay } onClick={!isBetting && initializeGrid} className={`cursor-pointer flex minesbtn space-x-[4.2rem] rounded-2xl w-[230px] p-[0.6rem] shadow-black shadow-md border-2 border-[#000]`}>
              <img src={play} alt='play'/>
              <p className="text-white">BET</p>
            </button>}
            </div>
          <div className='flex justify-center items-center rounded-full space-x-4 px-2 py-1 mt-4 mb-2 bg-[#0267a5] border border-[#05365a] text-white'>
              <div className="flex flex-col justify-center items-center">
                <p className="font-semibold text-sm">Bet USD</p>
                <button disabled={isBetting } onClick={() => setKeyPad(true)} className="flex space-x-4 rounded-full bg-[#014873] border-2 border-[#01304c] justify-center items-center w-[150px]">
                  <p className="font-semibold text-white">{betAmount}</p>
                </button>
              </div>

              <div>
              { showBetAmt &&
                <div className="absolute grid grid-cols-2 w-full left-0 bottom-[70px] rounded-lg bg-[#021538] gap-4 px-4 py-4">
                  <p className="text-white text-center col-span-2 font-semibold">Bet USD</p>
              {Array.from({ length: 15 }).map((_, i) => (
              <div onClick={() => setBetValue((i + 1) * 10)} key={i} className={`cursor-pointer ${(i + 1) * 10 === betAmount ? 'bg-[#0d4f84]' : ''} hover:bg-[#0d4f84] flex justify-center items-center rounded-full bg-[#043b5e]  px-10`}>
                <p className="text-sm text-center text-white">{((i + 1) * 10).toFixed(2)}</p>
              </div>
                ))}
              </div>
              }
              </div>

              <div>
              { keyPad &&
                <div className="absolute grid grid-cols-3 w-auto left-4 bottom-[70px] rounded-lg bg-[#0267a5] border border-[#01304c] gap-1 p-1">
            
              {keys.map((key, index) => (
              <div onClick={() => setBetValue(key === '⌫' ? betAmount <= '1' ? '1' :  betAmount.slice(0, -1) : betAmount >= balance ? balance: betAmount + key )} key={index} className={`cursor-pointer border border-[#01304c] flex justify-center items-center rounded-[6px] bg-[#0267a5] text-2xl  px-5`}>
                <p className=" text-center text-white">{key}</p>
              </div>
                ))}
              <div onClick={() => setKeyPad(false)} className={`cursor-pointer border border-[#01304c] flex justify-center items-center rounded-[6px] bg-[#033a5c] text-sm col-span-3`}>
                <p className=" text-center text-white">Done</p>
              </div>
              </div>
              }
              </div>

              <div className="flex space-x-1">
              <button disabled={isBetting } onClick={() => setBetAmount(betAmount <= '1' ? '1' : (parseInt(betAmount) - 10).toString())} className={`${!isBetting ? 'cursor-pointer' : ''} flex space-x-4 w-[32px] h-[32px] rounded-full bg-[#0267a5] border border-[#01304c] p-2`}>
                  <img className="w-[14px] h-[14px]" src={minus} alt='coin'/>
                </button>
                <button disabled={isBetting } onClick={() => setShowBetAmt(!showBetAmt)} className={`${!isBetting ? 'cursor-pointer' : ''} flex space-x-4 w-[32px] h-[32px] rounded-full bg-[#0267a5] border border-[#01304c] p-2`}>
                  <img className="w-[14px] h-[14px]" src={coin} alt='coin'/>
                </button>
                <button disabled={isBetting } onClick={() => setBetAmount(betAmount < balance ? (parseInt(betAmount) + 10).toString() : balance.toString())} className={`${!isBetting ? 'cursor-pointer' : ''} flex space-x-4 w-[32px] h-[32px] rounded-full bg-[#0267a5] border border-[#01304c] p-2`}>
                  <img className="w-[14px] h-[14px]" src={plus} alt='coin'/>
                </button>
              </div>
          </div>
          </div>

        <div className="flex justify-between items-center">
          <div className="flex space-x-4 rounded-full bg-[#0267a5] border border-[#043b5e] py-1 px-7">
            <p className="text-sm font-semibold text-white">Mines: 3</p>
            <img src={icondd} alt=''/>
          </div>
          <div className="flex space-x-2">
            <p className="text-white font-semibold">{balance.toFixed(2)} <span className="text-[#a4c9cf]">USD</span></p>
            <div onClick={() => setDropDown(!dropDown)} className="flex cursor-pointer rounded-full bg-[#0267a4] border border-[#043b5e] p-2">
            <img src={burger} alt=''/>
          </div>
          </div>

        </div>
        </div>

      </div>  
    </div>
  );
};

export default MinesGame;
